import { ThumbsDownIcon, ThumbsUpIcon } from 'lucide-react'

import { cn } from '@/utilities/ui'

export const BillApproval = ({
  mahaApproval,
}: {
  mahaApproval: 'not-reviewed' | 'approved' | 'not-approved'
}) => {
  return (
    <div
      className={cn(
        'flex items-center gap-2 rounded-full border border-border px-3.5 py-2 font-body text-reg font-medium',
        mahaApproval === 'not-approved' && 'border-tuscany-300 bg-tuscany-200 text-tuscany-600',
        mahaApproval === 'approved' && 'border-evergreen-200 bg-evergreen-100 text-evergreen-600',
      )}
    >
      {mahaApproval === 'approved' && <ThumbsUpIcon className="size-5" />}
      {mahaApproval === 'not-approved' && <ThumbsDownIcon className="size-5" />}
      {mahaApproval === 'approved' ? 'MAHA Approved' : 'MAHA Not Approved'}
    </div>
  )
}
